import * as React from 'react';
import { Button } from '@cian/ui-kit';

interface ISearchButtonProps {
  onClick(): void;
  loading: boolean;
}

export const SearchButton: React.FC<ISearchButtonProps> = ({ onClick, loading }) => {
  return (
    <Button size="XS" onClick={onClick} loading={loading}>
      Найти
    </Button>
  );
};
